<template>
  <div>
    <canvas ref="canvas"></canvas>
    <p>
      Safety Rank<br />
      Top <span>{{ ranking }}</span>%
    </p>
  </div>
</template>

<script>
export default {
  name: 'DriverPatternGauge',

  props: {
    rank: {
      type: Number,
      require: true
    }
  },

  data () {
    return {
      canvas: null,
      ctx: null,
      size: { width: 0, height: 0 },
      lineWidth: 14,
      radius: 0,
      center: { x: 0, y: 0 },
      img: null,
    }
  },

  computed: {
    ranking () {
      let result;
      if (this.rank > 100) result = 100;
      else if (this.rank < 0) result = 0;
      else result = Math.floor(this.rank);

      return result;
    }
  },

  mounted () {
    this.canvas = this.$refs.canvas;
    this.ctx = this.canvas.getContext('2d');

    this.img = new Image();
    this.img.src = require('@/assets/images/driver-pattern-popup-gauge.png')

    window.addEventListener('resize', this.resize);
    this.resize()
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.resize)
  },

  methods: {
    resize () {
      this.size.width = this.canvas.clientWidth;
      this.size.height = this.canvas.clientHeight;
      
      this.canvas.width = this.size.width * 2;
      this.canvas.height = this.size.height * 2;
      this.ctx.scale(2, 2);

      this.radius = this.size.width > this.size.height
        ? (this.size.height - this.lineWidth) / 2
        : (this.size.width - this.lineWidth) / 2

      this.center.x = this.size.width / 2;
      this.center.y = this.size.height / 2;

      this.render();
    },

    async render () {
      this.ctx.clearRect(0, 0, this.size.width, this.size.height);
      
      await this.drawImage();
      this.drawBackgorund();
      this.drawGauge();
    },

    drawImage () {
      if (this.img === null) {
        setTimeout(this.drawImage, 200);
        return;
      }

      this.ctx.beginPath();
      this.ctx.drawImage(this.img, this.center.x - this.img.naturalWidth / 2, this.center.y - this.img.naturalHeight);
      this.ctx.closePath();
    },

    drawBackgorund () {
      this.ctx.beginPath();
      this.ctx.arc(this.center.x, this.center.y, this.radius, 0, Math.PI * 2);
      this.ctx.lineWidth = this.lineWidth;
      this.ctx.strokeStyle = '#e9f2f9';
      this.ctx.stroke();
      this.ctx.closePath();
    },

    drawGauge () {
      this.ctx.save();
      this.ctx.translate(this.center.x, this.center.y);
      this.ctx.rotate(-90 * Math.PI / 180);
      this.ctx.beginPath();
      this.ctx.lineWidth = this.lineWidth;
      this.ctx.lineCap = 'round';
      const gradient = this.ctx.createLinearGradient(0,0, 100,0);
      gradient.addColorStop(0, '#7bb739');
      gradient.addColorStop(0.5, '#87bb36');
      gradient.addColorStop(1, '#7bb739');
      this.ctx.arc(0, 0, this.radius, 0, (360 - (360 / 100) * this.ranking) * Math.PI / 180, true);
      this.ctx.strokeStyle = gradient;
      this.ctx.stroke();
      this.ctx.closePath();
      this.ctx.restore();
    }
  }
}
</script>

<style scoped>
div {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
canvas {
  width: 100%;
  height: 100%;
  background: #fff;
}
p {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, calc(-50% + 22px));
  font-size: 12px;
  font-weight: 700;
  background: transparent;
  text-align: center;
  line-height: 1.2;
}
span {
  font-size: 20px;
  color: #8fbc31;
}
</style>